import * as z from "zod";

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Expected YYYY-MM-DD");

const dailyRow = z.object({
  date: z.string(),
  orders: z.number(),
  grossUsd: z.number(),
});

export const getHsaPaymentAnalytics = {
  name: "getHsaPaymentAnalytics" as const,
  input: z.object({ startDate: isoDate, endDate: isoDate }),
  output: z.object({
    series: z.array(dailyRow),
    totalOrders: z.number(),
    totalGrossUsd: z.number(),
    /** Merchants that returned data. */
    merchantsReporting: z.number(),
    /** All HSA-enabled merchants we attempted to query. */
    merchantsTotal: z.number(),
    /** Per-merchant breakdown for the queried date range. */
    perTeam: z.array(
      z.object({
        name: z.string(),
        storeUrl: z.string(),
        totalOrders: z.number(),
        totalGrossUsd: z.number(),
        reporting: z.boolean(),
        /** Per-day rows so the client can re-aggregate a merchant subset. */
        series: z.array(dailyRow),
      }),
    ),
  }),
};
